import { useMutation } from "urql";

import { UpdatePaymasterNotesDocument } from "../../../graphql/generated.ts";

export function useUpdatePaymasterNotes() {
  return useMutation(UpdatePaymasterNotesDocument);
}
